import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { TerminalsStore } from '../stores/TerminalsStore';
import { AuthService } from '../../../auth/core/services/AuthService';

export const terminalGuard: CanActivateFn = (route, state) => {
  if (!inject(TerminalsStore).selectedTerminal()) {
    inject(AuthService).logout();

    return false;
  }

  return true;
};
